const generalIT = {
    "modalConfirm": {
        "button": {
            "cancel": "Annulla",
            "confirm": "Conferma"
        }
    },
    "tableDropdown": {
        "action": "Azione",
        "edit": "Modifica",
        "delete": "Elimina",
        "viewDetails": "Visualizza Dettagli",
        "copyMLId": "Copia ID ML",
        "viewStats": "Visualizza Statistiche"
    },
    "tableModal": {
        "cancel": "Annulla",
        "confirm": "Conferma",
        "edit": "Modifica"
    },
    "invoiceModal": {
        "button": {
            "cancel": "Annulla",
            "confirm": "Conferma"
        }
    },
    "select": {
        "placeholder": "Seleziona..."
    },
    "asyncDropdown": {
        "placeholder": "Cerca...",
        "loading": "Caricamento...",
        "noResults": "Nessuna opzione",
        "blacklisted": "Lista Nera"
    },
    "table": {
        "noDataAvailable": "Nessun dato disponibile"
    },
    "tableHelper": {
        "loading": "Caricamento...",
        "error": "Si è verificato un errore",
        "noData": "Non ci sono dati disponibili"
    },
    "countriesSelect": {
        "placeholder": "Cerca paese..."
    },
    "consentModal": {
        "header": "Consenso Richiesto",
        "body": {
            "description": "Si prega di rivedere e accettare i nostri nuovi termini di consenso per continuare a utilizzare i nostri servizi.",
            "label": {
                "firstName": "Nome",
                "lastName": "Cognome",
                "email": "Email",
                "termsOfUsageAgreement": "Accetto i <1>Termini di Utilizzo</1>",
                "privacyPolicyAgreement": "Accetto la <1>Politica sulla Privacy</1>",
                "cookiePolicyAgreement": "Accetto la <1>Politica sui Cookie</1>"
            }
        },
        "button": {
            "submit": "Invia"
        }
    },
    "passwordResetModal": {
        "header": "Cambia la tua Password",
        "body": {
            "form": {
                "label": {
                    "currentPassword": "Password attuale",
                    "newPassword": "Nuova password",
                    "repeatNewPassword": "Ripeti nuova password"
                },
                "button": {
                    "submit": "Invia"
                },
                "message": {
                    "currentPasswordRequired": "La tua vecchia password è necessaria",
                    "newPasswordRequired": "È richiesta una nuova password",
                    "newPasswordMinLength": "La tua password deve essere lunga almeno 10 caratteri",
                    "newPasswordDifferentFromOld": "La nuova password deve essere diversa dalla vecchia password",
                    "newPasswordConfirmation": "La nuova password deve corrispondere"
                }
            }
        },
        "footer": {
            "note": "<strong>Nota: </strong>È passato un po' di tempo dall'ultimo aggiornamento della tua password. Per la tua sicurezza, reimposta la tua password."
        },
        "message": {
            "success": "La tua password è stata cambiata!",
            "error": "Qualcosa è andato storto! Aggiorna la pagina e riprova!"
        },
        "modal": {
            "confirm": {
                "header": "Sei sicuro di voler cambiare la tua password?",
                "body": "Si prega di confermare"
            }
        }
    },
    "qcFeedback": {
        "label": {
            "qcFeedback": "Feedback QC"
        }
    },
    "subUserFilter": {
        "label": {
            "subUser": "Sotto-Utente: "
        },
        "placeholder": {
            "subUser": "Seleziona Sotto-Utente"
        },
        "button": {
            "reset": "Reimposta"
        }
    },
    "footer": {
        "label": {
            "copyright": "Copyright © {{year}}",
            "allRightsReserved": "Tutti i diritti riservati.",
            "privacyPolicy": "Politica sulla Privacy",
            "termsAndConditions": "Termini e Condizioni"
        }
    },
    "promoBannerHeader": {
        "exclusiveOfferFor": "Offerta Esclusiva per",
        "off": "OFF",
        "promoCode": "Promo Code",
        "expiresIn": "Scade in",
        "clickHereToAvailThisOffer": "Clicca qui per sfruttare questa offerta",
        "availableOnAllSubscriptionPlans": "Disponibile su tutti i piani di abbonamento."
    },
    "promoBanner": {
        "exclusiveOfferFor": "Offerta Esclusiva per",
        "off": "OFF",
        "limitedTimePromoOffer": "Il tuo Promo Code temporaneo è stato creato esclusivamente per te. Non perdere questa opportunità!",
        "promoCode": "Il tuo Promo Code",
        "expiresIn": "Scade in",
        "days": "Giorni",
        "hours": "Ore",
        "minutes": "Minuti",
        "seconds": "Secondi",
        "availableOnAllSubscriptionPlans": "Questa offerta esclusiva è disponibile su tutti i piani di abbonamento."
    }
};

export default generalIT;